import { render, staticRenderFns } from "./InformationTips.vue?vue&type=template&id=2e5a07f6&"
import script from "./InformationTips.vue?vue&type=script&lang=js&"
export * from "./InformationTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports